import {
  Button,
  Card,
  DatePicker,
  Dialog,
  Form,
  Input,
  Message,
  Select,
} from '@alifd/next';
import { Image, Space, Table, Typography, Upload } from 'antd'; // dialog UI
import axios from 'axios';
import moment from 'moment';
import React, { Fragment, useEffect, useRef, useState } from 'react';
import { pdfjs } from 'react-pdf';
import Swal from 'sweetalert2';

import DownloadButton from '@/components/UI/DownloadButton';
import EditDocument from '@/components/UI/EditDocument';
import client from '@/lib/feathers';

import ezconImg from '../../../../../public/ezcon.png';
import RecordDescription from './components/RecordDescription';
import styles from './index.module.scss';

const { Column } = Table;

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
const Option = Select.Option;
const { Item } = Form;

const DownloadExcel = ({ example = false, deviceType, children }) => {
  const isNonConsumable = deviceType === 'nonConsumable';
  return (
    // <DownloadButton
    //   {...{
    //     url: '/ezcon/api/getExampleOrRealDataExcel',
    //     headers: {
    //       authorization: localStorage.getItem('feathers-jwt'),
    //     },
    //     params: {
    //       excelName: isNonConsumable
    //         ? 'assetManagementTransferExcel'
    //         : 'maintenanceManagementEquipmentInventoryExcel',
    //       example,
    //     },
    //     fileName: `${
    //       isNonConsumable
    //         ? '資產管理移交清冊表單'
    //         : '維運管理資(耗)材設備管理庫存表單'
    //     }_${moment().format('YYYYMMDD')}.xlsx`,
    //     responseFileType:
    //       'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',

    //     buttonProps: {
    //       type: 'secondary',
    //       style: {
    //         marginLeft: '10px',
    //         marginBottom: '10px',
    //       },
    //     },
    //   }}
    // >
    //   {children}
    // </DownloadButton>
    <DownloadButton
      {...{
        url: '/ezcon/api/getExampleOrRealDataExcel',
        headers: {
          authorization: localStorage.getItem('feathers-jwt'),
        },
        params: {
          excelName: isNonConsumable
            ? 'assetManagementTransferExcel'
            : 'maintenanceManagementEquipmentInventoryExcel',
          example,
        },
        fileName: `${
          isNonConsumable
            ? '資產管理移交清冊表單'
            : '維運管理資(耗)材設備管理庫存表單'
        }_${moment().format('YYYYMMDD')}.xlsx`,

        // 這裡改掉
        responseFileType: 'blob',

        buttonProps: {
          type: 'secondary',
          style: {
            marginLeft: '10px',
            marginBottom: '10px',
          },
        },
      }}
    >
      {children}
    </DownloadButton>
  );
};

const DeviceList = ({ showType = [] }) => {
  // menuCoVendor 廠商
  const menuCoVendor = client.service('menuCoVendor');
  // communityDevice 設備Table
  const communityDevice = client.service('communityDevice');

  const [deviceArr, setDeviceArr] = useState({
    consumable: [],
    nonConsumable: [],
  });
  const [vendorArr, setVendorArr] = useState([]);
  const [addDeviceDialog, setAddDeviceDialog] = useState(false);
  const [editDeviceDialog, setEditDeviceDialog] = useState(false);
  const [editDeviceIndex, setDeviceIndex] = useState('');
  const [rule, setRule] = useState('');
  const [ruleType, setRuleType] = useState('');
  const [todo, setTodo] = useState([]);

  const [editingObj, setEditingObj] = useState({});

  // communityRules 社區規範
  const communityRules = client.service('communityRules');
  const [communityRulesArr, setCommunityRulesArr] = useState([]);

  //  檔案Table
  const communityFiles = client.service('communityFiles');
  const [communityFilesArr, setCommunityFilesArr] = useState([]);
  const [files, setFiles] = useState('');
  const [filesType, setFilesType] = useState('');
  const [document, setDocument] = useState([]);
  const [sort, setSort] = useState({
    dataIndex: 'createdTime',
    order: 'desc',
  });

  // 查看記錄
  const [recordBeingViewed, setRecordBeingViewed] = useState(null);
  const [showRecordDescription, setShowRecordDescription] = useState(false);

  // Vendor
  const [deviceVendor, setDeviceVendor] = useState([]);
  const [vendorName, setVendorName] = useState('');

  // const [uploadPath, setUploadPath] = useState('');
  const [uploadData, setUploadData] = useState(null);
  const [attachment, setAttachment] = useState(null);
  const uploadRef = useRef(null);

  async function funFindRules(para) {
    const result = await communityRules.find({ query: para });
    return result && result.data ? result.data : [];
  }

  function rulesSort(a, b) {
    return a.title > b.title ? 1 : -1;
  }

  function serverRulesDataUpdate() {
    funFindRules({}).then((result) => {
      setCommunityRulesArr(result.sort(rulesSort));
    });
  }
  useEffect(() => {
    serverRulesDataUpdate();
  }, []);

  useEffect(() => {
    setEditingObj((prev) => ({ ...prev, deviceType: showType[0] }));
  }, [showType]);

  // funFindFiles
  async function funFindFiles(para) {
    const result = await communityFiles.find({ query: para });
    return result && result.data ? result.data : [];
  }

  function serverFilesDataUpdate() {
    funFindFiles({}).then((result) => {
      setCommunityFilesArr(result);
    });
  }
  useEffect(() => {
    serverFilesDataUpdate();
  }, []);

  // communityDevice
  async function funFind(para) {
    const result = await communityDevice.find({ query: para });

    return result && result.data ? result.data : [];
  }

  async function funRemove(id) {
    return await communityDevice.remove(id);
  }

  const serverDataUpdate = () => {
    funFind({
      deviceType: { $in: showType },
    }).then((result) => {
      const consumable = [];
      const nonConsumable = [];

      result.map((item) => {
        if (item.deviceType === '消耗用品') {
          consumable.push(item);
        } else {
          nonConsumable.push(item);
        }
        return true;
      });

      setDeviceArr({ consumable, nonConsumable });
    });
  };

  const onTableSort = (dataIndex, order) => {
    setSort({ dataIndex, order });
  };

  useEffect(() => {
    const { dataIndex, order } = sort;
    const sortFunc = (a, b) => {
      let [firstItem, secondItem] = [a, b];
      if (order === 'desc') {
        [firstItem, secondItem] = [b, a];
      }
      return firstItem[dataIndex]
        .toString()
        .localeCompare(secondItem[dataIndex].toString());
    };
    setDeviceArr((prev) => {
      const { consumable, nonConsumable } = prev;
      return {
        consumable: consumable.length > 0 ? consumable.sort(sortFunc) : [],
        nonConsumable:
          nonConsumable.length > 0 ? nonConsumable.sort(sortFunc) : [],
      };
    });
  }, [sort]);

  useEffect(() => {
    serverDataUpdate();
  }, []);

  // menuCoVendor

  async function findVendor(para) {
    const result = await menuCoVendor.find({ query: para });
    return result && result.data ? result.data : [];
  }

  function serverVendorDataUpdate() {
    findVendor({ activated: true }).then((result) => {
      setVendorArr(result);
    });
  }
  useEffect(() => {
    serverVendorDataUpdate();
  }, []);

  // 過濾廠商
  function communityVendorResult() {
    const vendor = vendorArr.map((x) => x.name);
    return vendor;
  }

  // 取得廠商
  function getVendor(val) {
    const vendorOne = vendorArr.filter((x) => x.name === val);

    if (vendorOne.length === 0) {
      Message.warning('資料匹配錯誤!請重新整理頁面');
    } else {
      const newTodo = {
        id: vendorOne[0]._id,
        name: val,
      };
      setDeviceVendor([newTodo]);
    }
  }

  // uploads files
  const [parsed, setParsed] = useState([]);
  const [parsed64, setParsed64] = useState([]); // Base64
  const [file, setFile] = useState('');
  const uploadFile = useRef(null);

  const beforeUpload = async () => {
    if (uploadFile.current.files.length > 0) {
      const isLt20M = uploadFile.current.files[0].size / 1024 / 1024 < 20;
      if (!isLt20M) {
        Message.error('Image must smaller than 20MB!');
        return Promise.reject();
      }
      return Promise.resolve(isLt20M);
    } else {
      setParsed64('');
    }
  };

  const handleFiles = async () => {
    try {
      await beforeUpload();
      const handledFiles = [...parsed];
      const data = await uploadFile.current.files[0];

      handledFiles.push(data);
      setParsed(handledFiles);

      // 轉Base64 上傳檔案後呈現沒有寫到DB
      const reader = new FileReader();
      reader.onload = function () {
        const dataURL = reader.result;
        setParsed64(dataURL);
      };
      reader.readAsDataURL(data);
    } catch (err) {
      console.log(err);
    }
  };

  const columns = [
    {
      title: '建立時間',
      dataIndex: 'createdTime',
      key: 'createdTime',
      render: (text) => {
        return moment(parseInt(text, 10)).format('YYYY-MM-DD');
      },
    },
    {
      title: '設備名稱',
      dataIndex: 'deviceName',
      key: 'deviceName',
    },
    // {
    //   title: '設備編號',
    //   dataIndex: 'deviceNumber',
    //   key: 'deviceNumber',
    // },
    {
      title: '保管人',
      dataIndex: 'deviceKeeper',
      key: 'deviceKeeper',
    },
    {
      title: '保管位置',
      dataIndex: 'deviceStorePlace',
      key: 'deviceStorePlace',
    },

    {
      title: '設備狀態',
      dataIndex: 'status',
      key: 'status',
    },
    {
      title: '購入日期',
      dataIndex: 'deviceDate',
      key: 'deviceDate',
      render: (text) => {
        return moment(parseInt(text, 10)).format('YYYY-MM-DD');
      },
    },
    {
      title: '操作',
      dataIndex: '_id',
      key: '_id',
      render: (text, record, index) => {
        return (
          <div className={styles.btn}>
            <Button
              onClick={() => {
                console.log({ record });
                setRecordBeingViewed(record);
                setShowRecordDescription(true);
              }}
            >
              查看
            </Button>
            <Button
              type="normal"
              onClick={() => {
                setEditingObj({ ...record });
                setDeviceVendor(record.deviceVendor);
                if (
                  Object.hasOwn(record, 'deviceVendor') &&
                  record.deviceVendor.length > 0
                ) {
                  setVendorName(record.deviceVendor[0].name);
                }
                setDeviceIndex(index);
                setEditDeviceDialog(true);
                setFile(record.files);
                setUploadData(record.specification);
              }}
            >
              編輯
            </Button>

            <Button
              type="primary"
              warning
              onClick={() => {
                Swal.fire({
                  title: `確定刪除(${record.deviceName})設備?`,
                  text: '刪除後將無法復原!!',
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#BEBEBE',
                  confirmButtonText: '確定',
                  cancelButtonText: '取消',
                }).then((result) => {
                  if (result.isConfirmed) {
                    Swal.fire('刪除!', '此設備已刪除', 'success');
                    funRemove(value).then(() => {
                      // removeItem();
                      // const prePages =
                      //   currentPage - 1 >= 0
                      //     ? currentPage - 1
                      //     : 0;
                      // if (
                      //   deviceArr.length - 1 <=
                      //   prePages * postsPerPage
                      // ) {
                      //   setCurrentPage(
                      //     currentPage - 1 < 1
                      //       ? 1
                      //       : currentPage - 1
                      //   );
                      // }
                      serverDataUpdate();
                    });
                  }
                });
              }}
            >
              刪除
            </Button>
          </div>
        );
      },
    },
  ];
  return (
    <>
      <Button
        onClick={() => {
          setAddDeviceDialog(true);
        }}
        style={{ marginBottom: '10px' }}
      >
        新增設備
      </Button>

      {/* 新增設備 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={addDeviceDialog}
        onOk={async () => {
          if (
            !ruleType &&
            !rule &&
            !editingObj.deviceNumber &&
            !editingObj.deviceKeeper &&
            !editingObj.deviceStorePlace
          ) {
            Message.warning('請確實填寫資料');
          } else if (!editingObj.deviceType) {
            Message.warning('請填寫設備類型');
          } else if (!editingObj.deviceName) {
            Message.warning('請填寫設備名稱');
          } else if (!editingObj.deviceDate) {
            Message.warning('請填寫購入日期');
          } else {
            const result = await Swal.fire({
              title: `確定新增(${
                editingObj.deviceName ? editingObj.deviceName : ''
              })設備?`,
              text: '請確認資料填寫完整!!',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#BEBEBE',
              confirmButtonText: '確定',
              cancelButtonText: '取消',
            });
            if (result.isConfirmed) {
              let newPicture = {};
              let newFile = {};
              if (uploadFile.current.files.length > 0) {
                const body = new FormData();
                body.append('files', uploadFile.current.files[0]);
                const res = await axios('/newUploads?type=communityDevice', {
                  method: 'POST',
                  data: body,
                  headers: {
                    authorization: window.localStorage['feathers-jwt'],
                  },
                });

                const { showPath, _id } = await res.data[0];
                newPicture = {
                  path: showPath,
                  name: uploadFile.current.files[0].name,
                  id: _id,
                };
              }
              if (uploadData) {
                const body = new FormData();
                body.append('files', uploadData);
                const res1 = await axios(
                  '/newUploads?type=communityDevice&category=規範',
                  {
                    method: 'POST',
                    data: body,
                    headers: {
                      authorization: window.localStorage['feathers-jwt'],
                    },
                  }
                );
                const { showPath, _id } = await res1.data[0];

                newFile = {
                  path: showPath,
                  name: uploadData.name,
                  id: _id,
                };
              }
              await communityDevice.create({
                ...editingObj,
                createdTime: new Date().getTime(),
                updatedTime: new Date().getTime(),
                deviceVendor,
                files: newPicture,
                specification: newFile,
                status: '正常',
                checkNum: null,
                checkList: null,
                checkWeek: null,
              });

              Swal.fire(
                '成功!',
                `設備(${
                  editingObj.deviceName ? editingObj.deviceName : ''
                })已新增`,
                'success'
              );
              serverDataUpdate();
              setRule('');
              setRuleType('');
              setFiles('');
              setFilesType('');
              setTodo([]);
              setDocument([]);
              setDeviceVendor([]);
              setEditingObj({});
              setFile('');
              setParsed64('');
              setAddDeviceDialog(false);
              setUploadData('');
            }
          }
        }}
        onCancel={() => {
          setRule('');
          setRuleType('');
          setFiles('');
          setFilesType('');
          setDocument([]);
          setDeviceVendor([]);
          setTodo([]);
          setEditingObj({});
          setFile('');
          setParsed64('');
          setAddDeviceDialog(false);
        }}
        onClose={() => {
          setRule('');
          setRuleType('');
          setFiles('');
          setFilesType('');
          setDocument([]);
          setDeviceVendor([]);
          setTodo([]);
          setEditingObj({});
          setFile('');
          setParsed64('');
          setAddDeviceDialog(false);
        }}
      >
        <Form>
          <h3>新增設備</h3>
          <Item label="設備類別" hidden>
            <Select
              className={styles.options2}
              value={showType[0]}
              onChange={(value) => {
                const obj = { deviceType: value };
                setEditingObj({ ...editingObj, ...obj });
              }}
            >
              <Option value="消耗用品">消耗品</Option>
              <Option value="非消耗品">非消耗品</Option>
            </Select>
          </Item>
          <Item label="設備名稱" required requiredMessage="請輸入設備名稱">
            <Input
              name="deviceName"
              placeholder="請輸入設備名稱"
              maxLength={25}
              hasLimitHint
              aria-label="input max length 25"
              onChange={(value) => {
                // setDeviceName(value);
                const obj = { deviceName: value };
                setEditingObj({ ...editingObj, ...obj });
              }}
            />
          </Item>
          <Item label="設備編號" required requiredMessage="請輸入設備編號">
            <Input
              name="deviceNumber"
              placeholder="請輸入設備編號"
              maxLength={25}
              hasLimitHint
              aria-label="input max length 25"
              onChange={(value) => {
                const obj = { deviceNumber: value };
                setEditingObj({ ...editingObj, ...obj });
              }}
            />
          </Item>
          <Item label="保管人" required requiredMessage="請輸入保管人">
            <Input
              name="deviceKeeper"
              placeholder="請輸入保管人"
              maxLength={25}
              hasLimitHint
              aria-label="input max length 25"
              onChange={(value) => {
                setEditingObj({ ...editingObj, deviceKeeper: value });
              }}
            />
          </Item>
          <Item label="保管位置" required requiredMessage="請輸入保管位置">
            <Input
              name="deviceStorePlace"
              placeholder="請輸入保管位置"
              maxLength={25}
              hasLimitHint
              aria-label="input max length 25"
              onChange={(value) => {
                setEditingObj({ ...editingObj, deviceStorePlace: value });
              }}
            />
          </Item>
          <Item label="設備廠商" required requiredMessage="請輸入設備廠商">
            <Select
              hasClear
              className={styles.options2}
              placeholder="請選擇設備廠商"
              dataSource={communityVendorResult()}
              onChange={(value) => {
                getVendor(value);
              }}
            />
          </Item>
          <Item label="設備價值" required requiredMessage="請輸入設備價值">
            <Input
              name="deviceMoney"
              placeholder="請輸入設備價值"
              innerAfter="元"
              hasLimitHint
              aria-label="input max length 25"
              onChange={(value) => {
                const obj = { deviceMoney: value };
                setEditingObj({ ...editingObj, ...obj });
              }}
            />
          </Item>
          <Item
            label="設備使用年限"
            required
            requiredMessage="請輸入設備使用年限"
          >
            <Input
              name="deviceYear"
              placeholder="請輸入設備使用年限"
              innerAfter="年"
              hasLimitHint
              aria-label="input max length 25"
              onChange={(value) => {
                const obj = { deviceYear: value };
                setEditingObj({ ...editingObj, ...obj });
              }}
            />
          </Item>
          <Item label="購入日期" required requiredMessage="請輸入購入日期">
            <DatePicker
              // disabledDate={disabledDate}
              hasClear={false}
              placeholder="選擇日期"
              value={
                editingObj.hasOwnProperty('deviceDate')
                  ? moment(parseInt(editingObj.deviceDate, 10)).format(
                      'YYYY-MM-DD'
                    )
                  : ''
              }
              onChange={(value) => {
                const obj = { deviceDate: moment(value).valueOf() };
                setEditingObj({ ...editingObj, ...obj });
              }}
            />
          </Item>
          <Item label="備註">
            <Input
              name="deviceNote"
              placeholder="請輸入備註"
              maxLength={150}
              hasLimitHint
              aria-label="input max length 150"
              onChange={(value) => {
                const obj = { deviceNote: value };
                setEditingObj({ ...editingObj, ...obj });
              }}
            />
          </Item>

          <Form.Item label="上傳設備照片">
            <Button
              onClick={() => {
                uploadFile.current.click();
              }}
            >
              {' '}
              {attachment ? '更換圖片' : '上傳圖片'}
            </Button>
            {uploadFile.current?.files.length > 0 && (
              <>
                <Typography.Text type="secondary">
                  {uploadFile.current.files[0].name}
                </Typography.Text>
                <Button
                  text
                  onClick={() => {
                    setParsed64([]);
                  }}
                  style={{ opacity: 0.45 }}
                >
                  清除
                </Button>
              </>
            )}
            <input
              style={{ display: 'none' }}
              accept="image/png, image/jpeg"
              ref={uploadFile}
              onChange={handleFiles}
              type="file"
              id="file"
              name="files"
              // multiple
            />
          </Form.Item>
          <Image
            className={styles.photo}
            src={`${parsed64.length > 0 ? parsed64 : ezconImg}`}
            alt="圖片"
          />
        </Form>
        <Form.Item label="上傳設備規範">
          <Space direction="vertical">
            <Button
              onClick={() => {
                uploadRef.current.click();
              }}
            >
              {attachment ? '更換附件' : '上傳附件'}
            </Button>
            {/* 註解為多檔上傳 */}
            {/* {uploadName &&
              uploadName.map((item, index) => (
                <>
                  <Typography.Text type="secondary">
                    {item}
                    <Button
                      text
                      onClick={() => {
                        uploadName.splice(index, 1);
                        setUploadName(uploadName);
                        setUploadData(uploadData.splice(index, 1));
                        // uploadData.splice(index, 1);
                        // setUploadData(uploadData);
                        // setUploadData(null);
                        // setUploadPath('');
                      }}
                      style={{ opacity: 0.45 }}
                    >
                      清除
                    </Button>
                  </Typography.Text>
                </>
              ))} */}
            {uploadData && (
              <>
                <Typography.Text type="secondary">
                  {uploadData.name}
                </Typography.Text>
                <Button
                  text
                  onClick={() => {
                    setUploadData(null);
                  }}
                  style={{ opacity: 0.45 }}
                >
                  清除
                </Button>
              </>
            )}
          </Space>
          <input
            ref={uploadRef}
            type="file"
            id="upload"
            // multiple="multiple"
            // value={uploadPath || ''}
            style={{ display: 'none' }}
            onChange={(e) => {
              const file = e.target.files[0];
              // 註解為多檔上傳
              // const uploadName = [];
              // const Data = [];
              // e.target.files.forEach((file) => {
              //   uploadName.push(file.name);
              //   Data.push(file);
              // });
              setUploadData(file);
              // setUploadName(uploadName);
            }}
          />
        </Form.Item>
      </Dialog>

      {/* 編輯設備 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={editDeviceDialog}
        onOk={async () => {
          if (!editingObj.deviceName && !editingObj.deviceVendor) {
            Message.warning('請確實填寫資料');
          } else if (!editingObj.deviceName) {
            Message.warning('請填寫設備名稱');
          } else if (!editingObj.deviceVendor) {
            Message.warning('請填寫設備廠商');
          } else {
            const result = await Swal.fire({
              title: `確定修改(${editingObj.deviceName})設備?`,
              text: '請確認修改資料!!',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#BEBEBE',
              confirmButtonText: '確定',
              cancelButtonText: '取消',
            });
            if (result.isConfirmed) {
              let newPicture = [];
              let newFile = [];
              if (uploadFile.current.files.length > 0) {
                const body = new FormData();
                body.append('files', uploadFile.current.files[0]);
                const res = await axios('/newUploads?type=communityDevice', {
                  method: 'POST',
                  data: body,
                  headers: {
                    authorization: window.localStorage['feathers-jwt'],
                  },
                });
                const { showPath, _id } = await res.data[0];
                newPicture = {
                  path: showPath,
                  name: uploadFile.current.files[0].name,
                  id: _id,
                };
                editingObj.files = newPicture;
              }
              if (uploadData) {
                const body = new FormData();
                body.append('files', uploadData);
                const res1 = await axios(
                  '/newUploads?type=communityDevice&category=規範',
                  {
                    method: 'POST',
                    data: body,
                    headers: {
                      authorization: window.localStorage['feathers-jwt'],
                    },
                  }
                );
                const { showPath, _id } = await res1.data[0];
                newFile = {
                  path: showPath,
                  name: uploadData.name,
                  id: _id,
                };
                editingObj.specification = newFile;
              }

              await communityDevice.patch(editingObj._id, {
                ...editingObj,
                updatedTime: new Date().getTime(),
                deviceVendor,
              });

              Message.success('修改成功');
              serverDataUpdate();
              setRule('');
              setRuleType('');
              setTodo([]);
              setFiles('');
              setFilesType('');
              setDocument([]);
              setDeviceVendor([]);
              setVendorName('');
              setFile('');
              setParsed64('');
              setEditDeviceDialog(false);
            }
          }
        }}
        onCancel={() => {
          setRule('');
          setRuleType('');
          setTodo([]);
          setFiles('');
          setFilesType('');
          setDocument([]);
          setDeviceVendor([]);
          setVendorName('');
          setFile('');
          setParsed64('');
          setEditDeviceDialog(false);
        }}
        onClose={() => {
          setRule('');
          setRuleType('');
          setTodo([]);
          setFiles('');
          setFilesType('');
          setDocument([]);
          setDeviceVendor([]);
          setVendorName('');
          setFile('');
          setParsed64('');
          setEditDeviceDialog(false);
        }}
      >
        <Form>
          <h3>編輯設備</h3>
          <Item label="設備類別" hidden>
            <Select
              value={showType[0]}
              name="deviceType"
              onChange={(value) => {
                // setDeviceName(value);
                const obj = { deviceType: value };
                setEditingObj({ ...editingObj, ...obj });
              }}
            >
              <Option value="消耗用品">消耗品</Option>
              <Option value="非消耗品">非消耗品</Option>
            </Select>
          </Item>
          <Item label="設備名稱" required requiredMessage="請輸入設備名稱">
            <Input
              value={
                editingObj.hasOwnProperty('deviceName')
                  ? editingObj.deviceName
                  : ''
              }
              name="deviceName"
              placeholder="請輸入設備名稱"
              maxLength={25}
              hasLimitHint
              aria-label="input max length 25"
              onChange={(value) => {
                // setDeviceName(value);
                const obj = { deviceName: value };
                setEditingObj({ ...editingObj, ...obj });
              }}
            />
          </Item>
          <Item label="設備編號" required requiredMessage="請輸入設備編號">
            <Input
              value={
                editingObj.hasOwnProperty('deviceNumber')
                  ? editingObj.deviceNumber
                  : ''
              }
              name="deviceNumber"
              placeholder="請輸入設備編號"
              maxLength={25}
              hasLimitHint
              aria-label="input max length 25"
              onChange={(value) => {
                const obj = { deviceNumber: value };
                setEditingObj({ ...editingObj, ...obj });
              }}
            />
          </Item>
          <Item label="保管人" required requiredMessage="請輸入保管人">
            <Input
              name="deviceKeeper"
              defaultValue={
                Object.hasOwn(editingObj, 'deviceKeeper')
                  ? editingObj.deviceKeeper
                  : ''
              }
              placeholder="請輸入保管人"
              maxLength={25}
              hasLimitHint
              aria-label="input max length 25"
              onChange={(value) => {
                setEditingObj({ ...editingObj, deviceKeeper: value });
              }}
            />
          </Item>
          <Item label="保管位置" required requiredMessage="請輸入保管位置">
            <Input
              name="deviceStorePlace"
              placeholder="請輸入保管位置"
              defaultValue={
                Object.hasOwn(editingObj, 'deviceStorePlace')
                  ? editingObj.deviceStorePlace
                  : ''
              }
              maxLength={25}
              hasLimitHint
              aria-label="input max length 25"
              onChange={(value) => {
                setEditingObj({ ...editingObj, deviceStorePlace: value });
              }}
            />
          </Item>
          <Item label="設備廠商" required requiredMessage="請輸入設備廠商">
            <Select
              hasClear
              className={styles.options2}
              placeholder="請選擇設備廠商"
              value={vendorName || ''}
              dataSource={communityVendorResult()}
              onChange={(value) => {
                getVendor(value);
                setVendorName(value);
              }}
            />
          </Item>
          <Item label="設備價值" required requiredMessage="請輸入設備價值">
            <Input
              value={
                editingObj.hasOwnProperty('deviceMoney')
                  ? editingObj.deviceMoney
                  : ''
              }
              innerAfter="元"
              name="deviceMoney"
              onChange={(value) => {
                const obj = { deviceMoney: value };
                setEditingObj({ ...editingObj, ...obj });
              }}
            />
          </Item>
          <Item
            label="設備使用年限"
            required
            requiredMessage="請輸入設備使用年限"
          >
            <Input
              value={
                editingObj.hasOwnProperty('deviceYear')
                  ? editingObj.deviceYear
                  : ''
              }
              innerAfter="年"
              name="deviceYear"
              onChange={(value) => {
                const obj = { deviceYear: value };
                setEditingObj({ ...editingObj, ...obj });
              }}
            />
          </Item>
          <Item label="購入日期" requiredMessage="請輸入購入日期">
            <DatePicker
              // disabledDate={disabledDate}
              hasClear={false}
              placeholder="選擇日期"
              value={
                editingObj.hasOwnProperty('deviceDate')
                  ? moment(editingObj.deviceDate).format('YYYY-MM-DD')
                  : ''
              }
              onChange={(value) => {
                const obj = { deviceDate: moment(value).valueOf() };
                setEditingObj({ ...editingObj, ...obj });
              }}
            />
          </Item>

          <Item label="備註">
            <Input
              name="deviceNote"
              placeholder="請輸入備註"
              value={
                editingObj.hasOwnProperty('deviceNote')
                  ? editingObj.deviceNote
                  : ''
              }
              maxLength={150}
              hasLimitHint
              aria-label="input max length 150"
              onChange={(value) => {
                const obj = { deviceNote: value };
                setEditingObj({ ...editingObj, ...obj });
              }}
            />
          </Item>
          <Form.Item label="上傳設備照片">
            <Button
              onClick={() => {
                uploadFile.current.click();
              }}
            >
              {attachment ? '更換圖片' : '上傳圖片'}
            </Button>
            <input
              accept="image/png, image/jpeg"
              ref={uploadFile}
              onChange={handleFiles}
              style={{ display: 'none' }}
              type="file"
              id="file"
              name="files"
              // multiple
            />
          </Form.Item>
          {/* <img style={{ width: "50px", height: "50px" }} src={`${parsed64.length > 0 ? parsed64 : file}`} alt="圖片"></img> */}
          <Image
            className={styles.photo}
            src={
              (parsed64.length > 0 && parsed64) ||
              (editingObj.hasOwnProperty('files') &&
                parsed64.length === 0 &&
                editingObj.files.path)
            }
            alt="圖片"
          />
        </Form>
        <Form.Item label="上傳設備規範">
          <Space direction="vertical">
            <Button
              onClick={() => {
                uploadRef.current.click();
              }}
            >
              {attachment ? '更換附件' : '上傳附件'}
            </Button>
            {uploadData && uploadData?.name && (
              <>
                <Typography.Text type="secondary">
                  {uploadData.name}
                </Typography.Text>
                <Button
                  text
                  onClick={() => {
                    setUploadData(null);
                  }}
                  style={{ opacity: 0.45 }}
                >
                  清除
                </Button>
              </>
            )}
          </Space>
          <input
            ref={uploadRef}
            type="file"
            id="upload"
            // value={uploadPath || ''}
            style={{ display: 'none' }}
            onChange={(e) => {
              const file = e.target.files[0];
              setUploadData(file);
            }}
          />
        </Form.Item>
      </Dialog>

      {/* 查看設備 */}
      <Dialog
        visible={showRecordDescription}
        onClose={() => setShowRecordDescription(false)}
        onOk={() => setShowRecordDescription(false)}
        okProps={{ children: '關閉' }}
        cancelProps={{ style: { display: 'none' } }}
        title="設備資料"
      >
        <RecordDescription record={recordBeingViewed} />
      </Dialog>

      {/* 顯示區域 */}
      {Object.entries(deviceArr).map(([deviceType, devices]) => {
        return (
          <Fragment key={deviceType}>
            {devices.length > 0 && (
              <>
                <DownloadExcel {...{ deviceType }} example>
                  下載範例表單
                </DownloadExcel>
                <DownloadExcel {...{ deviceType }}>匯出Excel</DownloadExcel>
                <Upload
                  showUploadList={false}
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  customRequest={async (options) => {
                    const uploadExcelFile = options.file;
                    const formData = new FormData();
                    formData.append('files', uploadExcelFile);
                    try {
                      await axios.post(
                        `/ezcon/api/${
                          deviceType === 'nonConsumable'
                            ? 'updateAssetManagementTransfer'
                            : 'updateMaintenanceManagementEquipmentInventory'
                        }`,
                        formData,
                        {
                          headers: {
                            authorization: window.localStorage['feathers-jwt'],
                          },
                        }
                      );
                      Message.success('上傳成功');
                      serverDataUpdate();
                    } catch (error) {
                      console.error(error);
                      Message.error('上傳失敗');
                    }
                  }}
                >
                  <Button
                    style={{
                      marginBottom: '10px',
                      marginLeft: '10px',
                    }}
                    type="secondary"
                  >
                    匯入Excel
                  </Button>
                </Upload>
                <EditDocument
                  name="資產管理"
                  style={{ marginBottom: 10, marginLeft: 10 }}
                />
                <Card free className={styles.Card}>
                  <Card.Content>
                    <h2>
                      {deviceType === 'consumable' ? '消耗品' : '設備資產'}
                    </h2>
                    {/* <Table dataSource={devices} onSort={onTableSort}>
                      <Column
                        sortable
                        title="建立時間"
                        dataIndex="createdTime"
                        width={150}
                        cell={(value) => {
                          return <>{moment(value).format('YYYY-MM-DD ')}</>;
                        }}
                      />

                      <Column
                        sortable
                        title="設備名稱"
                        dataIndex="deviceName"
                        width={150}
                      />
                      <Column
                        sortable
                        title="保管人"
                        dataIndex="deviceKeeper"
                        width={150}
                      />
                      <Column
                        sortable
                        title="購入日期"
                        dataIndex="deviceDate"
                        width={150}
                        cell={(value) => {
                          return <>{moment(value).format('YYYY-MM-DD')}</>;
                        }}
                      />
                      <Column title="設備狀態" dataIndex="status" width={100} />
                      <Column
                        title="操作"
                        width={200}
                        lock="right"
                        dataIndex="_id"
                        cell={(value, index, record) => {
                          return (
                            <div className={styles.btn}>
                              <Button
                                onClick={() => {
                                  console.log({ record });
                                  setRecordBeingViewed(record);
                                  setShowRecordDescription(true);
                                }}
                              >
                                查看
                              </Button>
                              <Button
                                type="normal"
                                onClick={() => {
                                  setEditingObj({ ...record });
                                  setDeviceVendor(record.deviceVendor);
                                  if (
                                    Object.hasOwn(record, 'deviceVendor') &&
                                    record.deviceVendor.length > 0
                                  ) {
                                    setVendorName(record.deviceVendor[0].name);
                                  }
                                  setDeviceIndex(index);
                                  setEditDeviceDialog(true);
                                  setFile(record.files);
                                  setUploadData(record.specification);
                                }}
                              >
                                編輯
                              </Button>

                              <Button
                                type="primary"
                                warning
                                onClick={() => {
                                  Swal.fire({
                                    title: `確定刪除(${record.deviceName})設備?`,
                                    text: '刪除後將無法復原!!',
                                    icon: 'warning',
                                    showCancelButton: true,
                                    confirmButtonColor: '#3085d6',
                                    cancelButtonColor: '#BEBEBE',
                                    confirmButtonText: '確定',
                                    cancelButtonText: '取消',
                                  }).then((result) => {
                                    if (result.isConfirmed) {
                                      Swal.fire(
                                        '刪除!',
                                        '此設備已刪除',
                                        'success'
                                      );
                                      funRemove(value).then(() => {
                                        // removeItem();
                                        // const prePages =
                                        //   currentPage - 1 >= 0
                                        //     ? currentPage - 1
                                        //     : 0;
                                        // if (
                                        //   deviceArr.length - 1 <=
                                        //   prePages * postsPerPage
                                        // ) {
                                        //   setCurrentPage(
                                        //     currentPage - 1 < 1
                                        //       ? 1
                                        //       : currentPage - 1
                                        //   );
                                        // }
                                        serverDataUpdate();
                                      });
                                    }
                                  });
                                }}
                              >
                                刪除
                              </Button>
                            </div>
                          );
                        }}
                      />
                    </Table> */}
                    <Table columns={columns} dataSource={devices} />
                  </Card.Content>
                </Card>
              </>
            )}
          </Fragment>
        );
      })}
    </>
  );
};

export default DeviceList;
